import { getInboxCustomOrderByGrouping } from '@griply/utils';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';
import { GroupByMode } from 'shared/types/sorting-mode';

export const useInboxCustomOrderByGrouping = (
  groupBy: GroupByMode | undefined | null,
) => {
  const user = useUser();

  return useMemo(
    () => getInboxCustomOrderByGrouping(user, groupBy),
    [user, groupBy],
  );
};
